// extracted by mini-css-extract-plugin
export var alt = "GlobalOccupancy-module--alt--a34c2";
export var bookMoreRooms = "GlobalOccupancy-module--bookMoreRooms--0e8d7";
export var container = "GlobalOccupancy-module--container--150c3";
export var desktopOnly = "GlobalOccupancy-module--desktopOnly--3b7a4";
export var main = "GlobalOccupancy-module--main--6f767";
export var mobileOnly = "GlobalOccupancy-module--mobileOnly--6deb3";
export var scroll = "GlobalOccupancy-module--scroll--ebbbd";
export var scrollHidden = "GlobalOccupancy-module--scrollHidden--bbe9f";
export var textLeft = "GlobalOccupancy-module--textLeft--4fa5e";
export var visuallyHidden = "GlobalOccupancy-module--visuallyHidden--b8af9";